/*
-----------------------------------------
Scss
-----------------------------------------
*/

import '~/sass/main.scss';

/*
-----------------------------------------
Vendors
-----------------------------------------
*/

import $ from 'jquery';
import objectFitImages from 'object-fit-images';
import 'popper.js';
import 'bootstrap';
import Swiper from 'swiper';

/*
-----------------------------------------
Init
-----------------------------------------
*/

$(function onReady() {

    /*
    -----------------------------------------
    Object-fit Polyfill -- https://github.com/bfred-it/object-fit-images
    -----------------------------------------
    */

    objectFitImages();

    /*
    -----------------------------------------
    Navigation Trigger
    -----------------------------------------
    */

    $('.nav-trigger').on('click', function(){
        var nav = $('.navigation');

        if($(this).hasClass('is-active')){
            $(this).removeClass('is-active');
            nav.removeClass('is-open');
            $('body').removeClass('no-scroll');
        }else{
            $(this).addClass('is-active');
            nav.addClass('is-open');
            $('body').addClass('no-scroll');
        }
    })

    /*
    -----------------------------------------
    Swiper -- http://idangero.us/swiper/api/
    -----------------------------------------
    */

    // Partners Slider
    new Swiper('.partners-slider', {
        slidesPerView: 10,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 1000,
            disableOnInteraction: false,
        },
        breakpoints: {
            1200: {
                slidesPerView: 8,
            },
            991: {
                slidesPerView: 6,
            },
            768: {
                slidesPerView: 4,
            },
            450: {
                slidesPerView: 3,
            },
        }
    });

    /*
    -----------------------------------------
    Contact Form
    -----------------------------------------
    */

    $("#contact-form").on("submit", function(e) {
        e.preventDefault();
        var form = $(this);
        var submitButton = form.find("button[type=submit]");
        submitButton.attr("disabled", true);
        submitButton.html('Sending ...');
        $.ajax({
            type: "POST",
            url: "contact.php",
            data: form.serialize(),
            success: function(data)
            {
                form[0].reset();
                alert("Merci pour votre message ! Nous vous répondrons dans les plus brefs délais");
                submitButton.removeAttr("disabled");
                submitButton.html('SEND');
            },
            error: function (data) {
                alert("Erreur , impossible d'envoyer le message !");
                submitButton.removeAttr("disabled");
                submitButton.html('SEND');
            }
        });
    })

});